import React, { Component, Fragment } from "react";
import "moment/locale/fr";
import _ from "lodash";

import ImportKpi from "./ImportKpi";
import List from "../../../components/list/List";
import Pagination from "components/pagination/Pagination";
import kpisColumnWithoutClient from "./KpisList.utils";
import { Checkbox, Select } from "antd";
import { sources } from "../../../configs/constants";

class KpisList extends Component {
  componentDidMount() {
    this.props.init("kpis");
  }

  render() {
    const { kpisList, page, pages, pageSize, nbItems, getNext, setMatchFilters, match, currentClientId } = this.props;
    const checked = match && match.client_id === currentClientId;
    const selectedSource = match && match.source;
    const kpisListColumn = checked
      ? kpisColumnWithoutClient
      : kpisColumnWithoutClient.concat([
          {
            title: "Clients Ids",
            dataIndex: "client_id",
            key: "client_id",
            render: (clientsId, record, index) => <Fragment>{Array.isArray(clientsId) && clientsId.join(";")}</Fragment>
          },
          ,
        ]);
    return (
      <div class="p-content-page-center p-content-page-center-full">
        <div class="p-content-page-center-header">
          <h2 class="p-content-page-center-header-title">Liste des KPIs</h2>
          <div class="p-content-page-center-header-buttons">
            <div class="p-content-page-center-header-buttons-item">
              <ImportKpi {...this.props} />
            </div>
          </div>
        </div>
        <div>
          <Checkbox
            ckecked={checked}
            onChange={() =>
              checked
                ? setMatchFilters({ ...match, client_id: undefined })
                : setMatchFilters({ ...match, client_id: currentClientId })
            }
          >
            Afficher uniquement les kpis du dossier
          </Checkbox>
          <Select
            allowClear
            showSearch
            placeholder="Source"
            style={{ width: 200 }}
            onChange={source => {
              setMatchFilters({ ...match, source });
            }}
            value={selectedSource}
          >
            {Object.keys(sources).map(key => (
              <Select.Option key={key} value={sources[key]}>
                {sources[key]}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div class="p-content-page-center-content">
          {!_.isEmpty(kpisList) && <List columns={kpisListColumn} data={kpisList} defaultText="Aucun kpi trouvé." />}
          <div className="p-al-right p-mrg-ver">
            <Pagination page={page} pages={pages} pageSize={pageSize} nbItems={nbItems} getNext={getNext} />
          </div>
        </div>
      </div>
    );
  }
}

export default KpisList;



// WEBPACK FOOTER //
// src/containers/admin/kpis/KpisList.js